import { render, staticRenderFns } from "./AddTransition.vue?vue&type=template&id=145912b3"
import script from "./AddTransition.vue?vue&type=script&lang=js"
export * from "./AddTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports